import { render, staticRenderFns } from "./epb-inline-tabs.component.vue?vue&type=template&id=2bbe954e&scoped=true"
import script from "./epb-inline-tabs.component.vue?vue&type=script&lang=ts"
export * from "./epb-inline-tabs.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-inline-tabs.component.vue?vue&type=style&index=0&id=2bbe954e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbe954e",
  null
  
)

export default component.exports